import type { AppContext } from 'next/app';
import Cookies from 'universal-cookie';

import { authGetCategoryByGradeIdAction } from '@/Module/Auth/Store/Action/authGetCategoryByGradeIdAction';
import { authGetMyPersonAction } from '@/Module/Auth/Store/Action/authGetMyPersonAction';
import {
  authSetLoggedInAction,
  authSetRubikaTokenAction,
  authSetShadTokenAction,
} from '@/Module/Auth/Store/Slice/AuthSlice';
import { isBrowser } from '@/Module/Core/Helper/isBrowser';
import { coreInitialedAction } from '@/Module/Core/Store/Action';
import { StrategyLevelQueryType } from '@/Module/Grade/Model/Enum/StrategylevelQueryType';
import { getCategoryCategoryListAction, getStrategyLevelInfoAction } from '@/Module/Grade/Store/Action';
import { getCategoryList } from '@/Module/Grade/Store/Query/CategoryListQuery';
import { getTotalNotificationAction } from '@/Module/Profile/Store/Action';
import type { IAppStore } from '@/Module/Store/Model';
import { getSubscriptionPlanListAction, getSubscriptionTypeListAction } from '@/Module/Subscription/Store/Action';
import { getSubscriptionsV2UserAction } from '@/Module/Subscription/Store/Action/getSubscriptionsV2UserAction';

export const getAppInitialData = async (store: IAppStore, context: AppContext) => {
  if (isBrowser()) return;
  if (store.getState().core.initialed) return;

  const urlParams = new URLSearchParams(context.ctx.req?.url?.split('?')[1] || '');
  const rubikaToken = urlParams.get('ut');
  const shadToken = urlParams.get('UserID');

  if (rubikaToken) {
    store.dispatch(authSetRubikaTokenAction(rubikaToken));
    return;
  }

  if (shadToken) {
    store.dispatch(authSetShadTokenAction(shadToken));
    return;
  }

  const cookies = new Cookies(context.ctx?.req?.headers?.cookie);
  const accessToken = cookies.get('accessToken');

  await Promise.allSettled([
    store.dispatch(getCategoryCategoryListAction({ hierarchy_level: 0 })),
    store.dispatch(getCategoryList.initiate()),
    store.dispatch(getSubscriptionTypeListAction()),
    store.dispatch(getSubscriptionPlanListAction()),
    store.dispatch(
      getStrategyLevelInfoAction({
        SortBy: 'Id',
        SortDesc: false,
        IsActive: true,
        Includes: StrategyLevelQueryType.APP_INITIAL_DATA,
      }),
    ),
  ]);

  if (accessToken) {
    await store
      .dispatch(authGetMyPersonAction(accessToken))
      .unwrap()
      .then(async () => {
        await Promise.allSettled([
          store.dispatch(getSubscriptionsV2UserAction(accessToken)),
          store.dispatch(authSetLoggedInAction(true)),
          store.dispatch(authGetCategoryByGradeIdAction(store.getState().auth?.person?.gradeId || 15)),
          store.dispatch(getTotalNotificationAction({ TypeId: 1, token: accessToken })),
        ]);
      })
      .catch(() => {});
  }

  await store.dispatch(coreInitialedAction());
};
